export const objeto = {
    administradoraId: 1
}

export const mockSelect = {
    algoDefaultId: 0,
    selectCombo : function ( item ) { this.algoDefaultId = item },
    arrayDeOpciones: [{ Id: 1, Descripcion: "Primera Opcion" }, { Id: 2, Descripcion: "Segunda Opcion" }, { Id: 3, Descripcion: "Tercera Opcion" }, { Id: 4, Descripcion: "Cuarta Opcion" }]
}

export const mockRadio = {
    array:[
        { Id: 1, Descripcion: "Domicilio Postal", Checked: true, Name: "Domicilio" },
        { Id: 2, Descripcion: "Correo Electronico", Checked: false, Name: "CorreoElectronico" },
        { Id: 3, Descripcion: "Pesos", Checked: true, Name: "Pesos" },
        { Id: 4, Descripcion: "Dolares", Checked: false, Name: "Dolares" },
    ]
}

export const mockEmision = {
    ATLAS_CUENTA_TIPO: {
        EMPRESAINDIVIDUOS:"I" 
    },
    PRODUCTO_VISA: {
        CostoEmision:"BP",
        PorcBonificacionEmisionDesde:"20",
        PorcBonificacionEmisionHasta:"95",
        CargoEnCuotas: 1,
        CargoEnCuotasDesde: undefined,
        CargoEnCuotasHasta:undefined,
    },


}

export const mockCorrespondencia = {
    domicilios: [{Id:1,Descripcion:"Av. Sarmiento 1822 - Castelar",CP:1821},{Id:2,Descripcion:"Santa Rosa 110 - Ituzaingo",CP:1356}],
    codigoGeografico:[{Id:1,Descripcion:"A199",CP:[1821,1935,1417]},{Id:2,Descripcion:"B123",CP:[1822,1936,1413]}],
    telefonos: [{Id:1,Descripcion:"555-5555"},{Id:2,Descripcion:"182-9551"}],
    celular: [{Id:1,Descripcion:"151122336644"},{Id:2,Descripcion:"1511558899"}],
}



export const solicitudes = [{
    Id:2,
    AdministradoraId:1,
    Numero:"039729",
    Tipo: "Internacional",
    Empresa: "Del Viso S.A.",
    Cuenta: "Yo que se V",
    Tarjetas:[{Nombre:"Roberto",Apellido:"Gomez Bolaños"},{Nombre:"Gregorio",Apellido:"Laferrere"}],
    SolicitudEstadoId: 2,
    FechaEstado:"18-03-2019",
    SolicitudTipoId:2,
    productoId: 1155,
    sucursalSeleccionadaId: 7,
    modeloLiquidacionId: 12,
    limitePrestamoId: 2,
    denominacionCuenta: "Empleados",
    descripcionCuenta: "Descripción Signature",
    codigoPlanta: "11",
    comercializadoraSeleccionadaId: "6",
    promotorSeleccionado:4,
    domicilioSeleccionadoId: 1,
    codigoGeograficoId: 1,
    telefonoSeleccionado: 1,
    celularSeleccionado: 1,
    email: "mimail@mail.com",
    correspondencia: "email",
    modeloDistribucionId: 1040,
    factorLimiteCompra: 2,
    carteraId: 1,
    limiteFinanciacion: 12,
    categoriaCajerosId: 2,
    formaPagoId: 3,
    tipoEmpresa: 8,
    codigoDistribucionSeleccionadoId: 2,
    formaDebitoId:1
},
{   Id:3,
    AdministradoraId:1,
    Numero:"022231",
    Tipo: "Internacional",
    Empresa: "Del Viso S.A.",
    Cuenta: "Satran V",
    Tarjetas:[{Nombre:"Roberto",Apellido:"Gomez Bolaños"},{Nombre:"Gregorio",Apellido:"Laferrere"},{Nombre:"Hank",Apellido:"Scorpio"},{Nombre:"Jim",Apellido:"Earthworm"},{Nombre:"Leono",Apellido:"Thundercat"},{Nombre:"Juan Carlos",Apellido:"Spinner"}],
    SolicitudEstadoId: 3,
    FechaEstado:"18-03-2019",
    SolicitudTipoId:3,
    sucursalSeleccionadaId: "3",
    modeloLiquidacionId: 12,
    productoId: 1155,
    limitePrestamoId: 2,
    denominacionCuenta: "Empleados",
    descripcionCuenta: "Descripción Signature",
    codigoPlanta: "11",
    comercializadoraSeleccionadaId: "6",
    promotorSeleccionado:4,
    domicilioSeleccionadoId: 1,
    codigoGeograficoId: 1,
    telefonoSeleccionado: 1,
    celularSeleccionado: 1,
    email: "mimail@mail.com",
    correspondencia: "email",
    modeloDistribucionId: 1040,
    factorLimiteCompra: 2,
    carteraId: 1,
    limiteFinanciacion: 12,
    categoriaCajerosId: 2,
    formaPagoId: 2287,
    tipoEmpresa: 8,
    codigoDistribucionSeleccionadoId: 2,
    tipoEmpresa:9
},
{   Id:4,
    denominacionCuenta: "Empresa",
    AdministradoraId:2,
    Numero:"024521",
    Tipo: "Empresa",
    Empresa: "La Salteña",
    Cuenta: "Sarnoso C",
    Tarjetas:[{Nombre:"Hank",Apellido:"Scorpio"},{Nombre:"Jim",Apellido:"Earthworm"},{Nombre:"Leono",Apellido:"Thundercat"},{Nombre:"Juan Carlos",Apellido:"Spinner"}],
    SolicitudEstadoId: 4,
    FechaEstado:"18-03-2019",
    SolicitudTipoId:1,
    productoId: 1156,
    grupoAfinidadSeleccionadoId: 5,
    segmentoCarteraSeleccionadoId: 4,
    promotorSeleccionado: 12,
    domicilioSeleccionadoId: 1,
    telefonoSeleccionado: 2,
    correspondencia: "email",
    email: "aguantelarralde@carajo.com",
    grabadoCuartaLinea: "alta cuarta linea",
    limiteCompra: 23000,
    CLCC: 3,
    limiteFinanciacion: 26,
    topePagoMinimo: 16,
    carteraId: 7,
    formaPagoId: 2306,
    formaDebitoId: 1541,
    tipoEmpresa:9,
    sucursalSeleccionadaId: 3,
    preEmisionId:0,
    preEmisionId:0,
    altaPosDatadaId: "N",
    retencionTarjetaId: "N"
},
{   Id:5,
    AdministradoraId:2,
    denominacionCuenta: "Compras",
    Numero:"087631",
    Tipo: "Tarjeta Individual",
    Empresa: "La Salteña",
    Cuenta: "Zorro 1",
    Tarjetas:[{Nombre:"Roberto",Apellido:"Gomez Bolaños"},{Nombre:"Gregorio",Apellido:"Laferrere"},{Nombre:"Hank",Apellido:"Scorpio"},{Nombre:"Leono",Apellido:"Thundercat"},{Nombre:"Juan Carlos",Apellido:"Spinner"}],
    SolicitudEstadoId: 5,
    FechaEstado:"18-03-2019",
    SolicitudTipoId:2,
    productoId: 1156,
    grupoAfinidadSeleccionadoId: 5,
    segmentoCarteraSeleccionadoId: 4,
    promotorSeleccionado: 12,
    domicilioSeleccionadoId: 1,
    telefonoSeleccionado: 2,
    correspondencia: "email",
    email: "aguantelarralde@carajo.com",
    grabadoCuartaLinea: "alta cuarta linea",
    limiteCompra: 23000,
    CLCC: 3,
    limiteFinanciacion: 26,
    topePagoMinimo: 16,
    carteraId: 7,
    formaPagoId: 2306,
    formaDebitoId: 1541,
    tipoEmpresa:9,
    sucursalSeleccionadaId: 3,
    preEmisionId:0,
    preEmisionId:0,
    altaPosDatadaId: "N",
    retencionTarjetaId: "N"
},
{   Id:7,
    AdministradoraId:3,
    Numero:"022236",
    Tipo: "Gold",
    denominacionCuenta: "Gerentes",
    Empresa: "Bimbo",
    Cuenta: "Sarna 4",
    Tarjetas:[{Nombre:"Roberto",Apellido:"Gomez Bolaños"},{Nombre:"Gregorio",Apellido:"Laferrere"},{Nombre:"Hank",Apellido:"Scorpio"}],
    SolicitudEstadoId: 7,
    FechaEstado:"18-03-2019",
    SolicitudTipoId:3
},
{   Id:8,
    AdministradoraId:2,
    Numero:"022234",
    Tipo: "Nacional",
    Empresa: "LoTrack S.R.L.",
    denominacionCuenta: "Empresa",
    Cuenta: "Pobre 1",
    Tarjetas:[{Nombre:"Roberto",Apellido:"Gomez Bolaños"},{Nombre:"Gregorio",Apellido:"Laferrere"},{Nombre:"Hank",Apellido:"Scorpio"},{Nombre:"Jim",Apellido:"Earthworm"},{Nombre:"Leono",Apellido:"Thundercat"},{Nombre:"Juan Carlos",Apellido:"Spinner"}],
    SolicitudEstadoId: 8,
    FechaEstado:"18-03-2019",
    SolicitudTipoId:1,
    productoId: 1156,
    grupoAfinidadSeleccionadoId: 5,
    segmentoCarteraSeleccionadoId: 4,
    promotorSeleccionado: 12,
    domicilioSeleccionadoId: 1,
    telefonoSeleccionado: 2,
    correspondencia: "email",
    email: "aguantelarralde@carajo.com",
    grabadoCuartaLinea: "alta cuarta linea",
    limiteCompra: 23000,
    CLCC: 3,
    limiteFinanciacion: 26,
    topePagoMinimo: 16,
    carteraId: 7,
    formaPagoId: 2306,
    formaDebitoId: 1541,
    tipoEmpresa:9,
    sucursalSeleccionadaId: 3,
    preEmisionId:0,
    preEmisionId:0,
    altaPosDatadaId: "N",
    retencionTarjetaId: "N"
},
{   
    Id:9,
    AdministradoraId:3,
    Numero:"022231",
    Tipo: "Gold",
    Empresa: "Bimbo",
    denominacionCuenta:"Gerentes",
    Cuenta: "Yerbita",
    Tarjetas:[{Nombre:"Roberto",Apellido:"Gomez Bolaños"},{Nombre:"Gregorio",Apellido:"Laferrere"},{Nombre:"Hank",Apellido:"Scorpio"},{Nombre:"Jim",Apellido:"Earthworm"},{Nombre:"Leono",Apellido:"Thundercat"}],
    SolicitudEstadoId: 9,
    FechaEstado:"18-03-2019",
    SolicitudTipoId:2
},
{   Id:10,
    AdministradoraId:3,
    Numero:"022231",
    Tipo: "Nacional",
    denominacionCuenta: "Viajes Personal",
    Empresa: "Bimbo",
    Cuenta: "Sarnoso 2",
    Tarjetas:[{Nombre:"Roberto",Apellido:"Gomez Bolaños"},{Nombre:"Gregorio",Apellido:"Laferrere"},{Nombre:"Hank",Apellido:"Scorpio"},{Nombre:"Jim",Apellido:"Earthworm"},{Nombre:"Leono",Apellido:"Thundercat"},{Nombre:"Juan Carlos",Apellido:"Spinner"},{Nombre:"Opa",Apellido:"Bratan"}],
    SolicitudEstadoId: 10,
    FechaEstado:"18-03-2019",
    SolicitudTipoId:2
},
{   Id:11,
    AdministradoraId:2,
    Numero:"022231",
    denominacionCuenta: "Compras",
    Tipo: "Nacional",
    Empresa: "La Salteña",
    Cuenta: "Sarnoso 2",
    Tarjetas:[{Nombre:"Roberto",Apellido:"Gomez Bolaños"}],
    SolicitudEstadoId: 11,
    FechaEstado:"18-03-2019",
    SolicitudTipoId:3,
    productoId: 1156,
    grupoAfinidadSeleccionadoId: 5,
    segmentoCarteraSeleccionadoId: 4,
    promotorSeleccionado: 12,
    domicilioSeleccionadoId: 1,
    telefonoSeleccionado: 2,
    correspondencia: "email",
    email: "aguantelarralde@carajo.com",
    grabadoCuartaLinea: "alta cuarta linea",
    limiteCompra: 23000,
    CLCC: 3,
    limiteFinanciacion: 26,
    topePagoMinimo: 16,
    carteraId: 7,
    formaPagoId: 2306,
    formaDebitoId: 1541,
    tipoEmpresa:9,
    sucursalSeleccionadaId: 3,
    preEmisionId:0,
    preEmisionId:0,
    altaPosDatadaId: "N",
    retencionTarjetaId: "N",
    preEmisionId:0,
    preEmisionId:0,
    altaPosDatadaId: "N",
    retencionTarjetaId: "N"
}]

export const cuentas = [
    {
        Id:1,
        AdministradoraId:3,
        denominacionCuenta:"Sub Gerentes",
        CuentaTipoId:2,
        Tipo: "Gold",
        EmpresaEstadoId: 2,
        Tarjetas:[{Nombre:"Roberto",Apellido:"Gomez Bolaños"},{Nombre:"Macarena",Apellido:"Dalealegríatucuerpo"}],
        Limite: "2.000",
        Sucursal:"18 - San Antonio",
        EmpresaId:3,
        EmpresaIndividuos:"E"
    },{
    Id:2,
    AdministradoraId:2,
    denominacionCuenta:"Bimbo",
    CuentaTipoId:1,
    Tipo: "Empresa",
    EmpresaEstadoId: 2,
    Tarjetas:[{Nombre:"Juana",Apellido:"Lacubana"},{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"},{Nombre:"Pedro",Apellido:"Elescamoso"}],
    Limite: "80.000",
    Sucursal:"28 - Las Toninas",
    EmpresaId:1,
    EmpresaIndividuos:"E"
},
{   
    Id:3,
    AdministradoraId:2,
    denominacionCuenta:"Gerentes",
    Tipo: "Internacional",
    CuentaTipoId:2,
    EmpresaEstadoId: 2,
    Tarjetas:[{Nombre:"Juana",Apellido:"Lacubana"},{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"}],
    Limite: "120.000",
    Sucursal:"21 - Gonzalez Catán",
    EmpresaId:1,
    EmpresaIndividuos:"E"
},
{
    Id:4,
    AdministradoraId:2,
    denominacionCuenta:"Personal Viajes",
    CuentaTipoId:2,
    Tipo: "Internacional",
    EmpresaEstadoId: 3,
    Tarjetas:[{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"},{Nombre:"Pedro",Apellido:"Elescamoso"}],
    Limite: "2.000.000",
    Sucursal:"5 - San Justo",
    EmpresaId:1
},
,
{
    Id:5,
    AdministradoraId:1,
    denominacionCuenta:"Del Viso S.A.",
    CuentaTipoId:1,
    Tipo: "Empresa",
    EmpresaEstadoId: 2,
    Tarjetas:[{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"},{Nombre:"Pedro",Apellido:"Elescamoso"}],
    Limite: "2.000",
    Sucursal:"22 - Lavalle",
    EmpresaId:2
},
{
    Id:6,
    AdministradoraId:1,
    denominacionCuenta:"Empleados",
    CuentaTipoId:2,
    Tipo: "Internacional",
    EmpresaEstadoId: 2,
    Tarjetas:[{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"}],
    Limite: "2.000",
    Sucursal:"22 - Lavalle",
    EmpresaId:2
},
{
    Id:7,
    AdministradoraId:1,
    denominacionCuenta:"La Empresa S.A.",
    CuentaTipoId:1,
    Tipo: "Empresa",
    EmpresaEstadoId: 2,
    Tarjetas:[{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"},{Nombre:"Pedro",Apellido:"Elescamoso"}],
    Limite: "2.000",
    Sucursal:"22 - Córdoba",
    EmpresaId:3
},
{
    Id:8,
    AdministradoraId:1,
    denominacionCuenta:"Cuenta 25",
    CuentaTipoId:2,
    Tipo: "Signature",
    EmpresaEstadoId: 2,
    Tarjetas:[{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"}],
    Limite: "2.000",
    Sucursal:"22 - San Luis",
    EmpresaId:3
},
{
    Id:9,
    AdministradoraId:3,
    denominacionCuenta:"Cuenta Master2",
    CuentaTipoId:2,
    Tipo: "Master Chief",
    EmpresaEstadoId: 2,
    Tarjetas:[{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"},{Nombre:"Pedro",Apellido:"Elescamoso"}],
    Limite: "2.000",
    Sucursal:"22 - San Luis",
    EmpresaId:4
},

{
    Id:10,
    AdministradoraId:1,
    denominacionCuenta:"Viajes Gerentes",
    CuentaTipoId:2,
    Tipo: "Nacional",
    EmpresaEstadoId: 2,
    Tarjetas:[{Nombre:"Ricky",Apellido:"Maravilla"},{Nombre:"Pedro",Apellido:"Elescamoso"}],
    Limite: "2.000",
    Sucursal:"22 - Lavalle",
    EmpresaId:2
},
{
    Id:11,
    AdministradoraId:1,
    denominacionCuenta:"Compras 2",
    CuentaTipoId:2,
    Tipo: "Internacional",
    EmpresaEstadoId: 2,
    Tarjetas:[{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"},{Nombre:"Pedro",Apellido:"Elescamoso"}],
    Limite: "2.000",
    Sucursal:"5 - San Justo",
    EmpresaId:2
},
{
    Id:12,
    AdministradoraId:2,
    denominacionCuenta:"Maestranzas",
    CuentaTipoId:2,
    Tipo: "Internacional",
    EmpresaEstadoId: 3,
    Tarjetas:[{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"}],
    Limite: "2.000",
    Sucursal:"22 - San Luis",
    EmpresaId:2
},
{
    Id:13,
    AdministradoraId:3,
    denominacionCuenta:"Cunnington",
    CuentaTipoId:1,
    Tipo: "Gold",
    EmpresaEstadoId: 2,
    Tarjetas:[{Nombre:"Roberte",Apellido:"Galán"},{Nombre:"Ricky",Apellido:"Maravilla"},{Nombre:"Pedro",Apellido:"Elescamoso"}],
    Limite: "2.000",
    Sucursal:"22 - Córdoba",
    EmpresaId:3
}
]